module.exports = __webpack_public_path__ + "static/img/well-being.3191e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/well-being.png
// module id = XJzf
// module chunks = 0